export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70a592c22469ad37ac2747e4b0ef6a8647bbb904f3&name=pushAdClickData!'